export { default as MollieComponent } from "./MollieComponent";
